import { z } from 'zod';

export const suspendUserSchema = z.object({
  reason: z.string().min(10, 'Reason must be at least 10 characters'),
});
export type SuspendUserInput = z.infer<typeof suspendUserSchema>;

export const changeRoleSchema = z.object({
  role: z.enum(['USER', 'EDITOR', 'ADMIN', 'SUPER_ADMIN']),
});
export type ChangeRoleInput = z.infer<typeof changeRoleSchema>;

export const refundPaymentSchema = z
  .object({
    amount: z.coerce.number().positive().optional(),
    reason: z.string().min(10, 'Reason must be at least 10 characters'),
    maxAmount: z.number().int().positive(),
  })
  .refine((d) => d.amount === undefined || d.amount <= d.maxAmount, {
    path: ['amount'],
    message: 'Refund amount cannot exceed payment amount',
  });
export type RefundPaymentInput = z.infer<typeof refundPaymentSchema>;

export const bulkSuspendSchema = z.object({
  reason: z.string().min(10, 'Reason must be at least 10 characters'),
});
export type BulkSuspendInput = z.infer<typeof bulkSuspendSchema>;

// Grant/revoke beta publish credits. `amount` is a count (not money); reason is
// optional audit context. Same shape for both actions.
export const creditsSchema = z.object({
  amount: z.coerce
    .number()
    .int('Enter a whole number')
    .min(1, 'Enter at least 1 credit')
    .max(1000, 'Maximum 1000 at a time'),
  reason: z.string().max(500).optional(),
});
export type CreditsInput = z.infer<typeof creditsSchema>;
